import React, { useState, useEffect } from 'react';
import {Row, Col, FloatingLabel ,Tooltip, OverlayTrigger, Form, Dropdown, DropdownButton, ButtonGroup} from 'react-bootstrap'
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import dashboardIcon from '../../dist/images/icons/menu/dashboard.png'
import categoryIcon from '../../dist/images/icons/menu/category.png'
import recordsIcon from '../../dist/images/icons/menu/records.png'
import logoIcon from '../../dist/images/logoIcon.png'
import logo from '../../dist/images/logo.png'
import profileIcon from '../../dist/images/icons/profile.png'


const Header = ({ user, onLogout }) => {  

   // useEffect(() => {
   //  const timer = setTimeout(() => {
   //    alert('Session expired. Logging out.');
   //    onLogout();
   //  }, 60000); // 1 minute session timeout

   //    return () => clearTimeout(timer);
   //  }, [onLogout]);

   const location = useLocation();
   const navigate = useNavigate()

   const menuOptions = [
      {id: 1, navbar_name: "Dashboard", navbar_icon: dashboardIcon, navbar_path:"dashboard"},
      {id: 2, navbar_name: "Records", navbar_icon: recordsIcon, navbar_path:"records"},
      {id: 3, navbar_name: "Categories", navbar_icon: categoryIcon, navbar_path:"categories"}
   ]

   const handleHomePageChange = () => {
      navigate('/')
   }

   const handleLogoutChange = () => {
    toast.success("Logout Successfully")
    setTimeout(() => {
      onLogout()
    }, 1000)
    
   }

  return (
    <div className="header-wrapper">
      <div className="logo-wrapper">
          <img src={logo} className="brand-logo-icon" onClick={handleHomePageChange}/>
      </div>
      <div className="nav-bar p-3">
        <ul type="none">
            {menuOptions?.map(nav => (
              <li
                className={location.pathname.startsWith(`/${nav.navbar_path}`) ? "nav-link active" : "nav-link"}
                key={nav.id}
              >
                <OverlayTrigger
                  placement="right" // You can adjust this to "top", "left", or "right"
                  overlay={<Tooltip id={`tooltip-${nav.id}`}>{nav.navbar_name}</Tooltip>} // Directly passing Tooltip
                >
                  <Link to={`/${nav.navbar_path}/`}>
                    <img
                      src={nav.navbar_icon}
                      alt={nav.navbar_name}
                    />
                  </Link>
                </OverlayTrigger>
              </li>
            ))}
        </ul>
      </div>
      <div className="profile-wrapper">      
          <DropdownButton
            as={ButtonGroup}
            drop="up"
            title={<img src={profileIcon} className="profile-icon"/>}
          >          
            <Dropdown.Item onClick={handleLogoutChange}>Logout</Dropdown.Item>
          </DropdownButton>

      </div>
     {/* <ToastContainer autoClose={1500} />*/}
    </div>
  );
};

export default Header;